var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"etiqueta--campo"},[_vm._v(" "+_vm._s(_vm.texto)+" "),(_vm.requerido)?_c('label',{staticClass:"etiqueta--campo__marca"},[_vm._v(" *")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }